export const journeysUrl = 'journeys/';
export const journeyUrl = (journeyId: string) => `journeys/${journeyId}/`;
export const travelUrl = 'search/travel/'; // CORE API
